import React from "react";
import { Link } from "react-router-dom";

interface HeaderItem {
  image?: string;
  alt?: string;
  showButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
}

const HeaderImage: React.FC<HeaderItem> = ({
  image,
  alt,
  showButton = false,
  buttonText = "Explore",
  buttonLink = "#",
}) => {
  const displayImage = image ? image : "/assets/images/hero.jpeg";
  const altTitle = alt ? alt : "header";

  return (
    <div className="relative mt-10 mx-4 md:mx-24">
      <img
        src={displayImage}
        alt={altTitle}
        className={`w-full h-full lg:h-[70vh] ${image ? "object-fill md:object-contain" : "object-fill md:object-cover"}`}
      />

      {showButton && (
        <Link
          to={buttonLink}
          target="_blank"
          className="absolute left-6 bottom-6 md:left-18 md:bottom-20 lg:left-28 lg:bottom-28 bg-green-700 text-white px-6 py-2 rounded-md font-semibold shadow-lg hover:bg-green-800 transition"
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
};

export default HeaderImage;
